import { render, staticRenderFns } from "./edit_cameras.vue?vue&type=template&id=99e2e06a&scoped=true&"
import script from "./edit_cameras.vue?vue&type=script&lang=js&"
export * from "./edit_cameras.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99e2e06a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/imc/portal/dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('99e2e06a')) {
      api.createRecord('99e2e06a', component.options)
    } else {
      api.reload('99e2e06a', component.options)
    }
    module.hot.accept("./edit_cameras.vue?vue&type=template&id=99e2e06a&scoped=true&", function () {
      api.rerender('99e2e06a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/js/components/com_sb/cameras/edit_cameras.vue"
export default component.exports